module.exports = __webpack_public_path__ + "static/img/ex_default_bg.7f99c871.jpg";